import axios from "axios";

const API_URL_GET_HOMES = "/akerayu-dh-aa-ad/property/get";
const API_URL_ADMIN_LOGIN = "/akerayu-dh-aa-ad/login";
const API_URL_ADMIN_SIGNUP = "/akerayu-dh-aa-ad/signup";
const API_URL_CHANGE_HOME_STATUS = "/akerayu-dh-aa-ad/property/update";
const API_URL_DISMISS_REPORT = "/akerayu-dh-aa-ad/report/dismiss";
const API_URL_ADMINISLOGGEDIN = "/akerayu-dh-aa-ad/loggedin";
const API_URL_COUNTUSER = "/akerayu-dh-aa-ad/usercounter";
const API_URL_INDICATOR = "/akerayu-dh-aa-ad/indicator";
const API_URL_COUNTPROPERTY = "/akerayu-dh-aa-ad/propertycounter";
const API_URL_VIEWCOUNTER = "/akerayu-dh-aa-ad/viewcounter";
const API_URL_MESSAGECOUNTER = "/akerayu-dh-aa-ad/messagecounter";
const API_URL_GETREPORT = "/akerayu-dh-aa-ad/report/get";
const API_URL_GETFAQ = "/akerayu-dh-aa-ad/faq/get";

const API_URL_POST_FAQ = "/akerayu-dh-aa-ad/faq/post";
const API_URL_UPDATE_FAQ = "/akerayu-dh-aa-ad/faq/update";
const API_URL_UPDATE_FAQ_CATEGORY = "/akerayu-dh-aa-ad/faq/category/update";
const API_URL_DELETE_FAQ = "/akerayu-dh-aa-ad/faq/delete";
const API_URL_POST_FAQ_CATEGORY = "/akerayu-dh-aa-ad/faq/category/post";
const API_URL_POST_DOWNLOAD_IMAGE = "/akerayu-dh-aa-ad/download/image";
const API_URL_GET_FAQ_CATEGORY = "/akerayu-dh-aa-ad/faq/category/get";
const API_URL_GET_HISTORY = "/akerayu-dh-aa-ad/history/get";

//register
const adminRegisterService = async (userData) => {
  const response = await axios.post(API_URL_ADMIN_SIGNUP, userData, {
    withCredentials: true,
  });
  if (response.data) {
    return response.data;
  }
};

//login
const adminLoginService = async (userData) => {
  const response = await axios.post(API_URL_ADMIN_LOGIN, userData);

  if (response.data) {
    return response.data;
  }
};

const adminGetAllHomesService = async (data) => {
  const response = await axios.post(API_URL_GET_HOMES, data);

  if (response.data) {
    return response.data;
  }
};

const adminChangeStatusHomeService = async (data) => {
  const response = await axios.put(API_URL_CHANGE_HOME_STATUS, data);

  if (response.data) {
    return response.data;
  }
};
const adminDismissReportService = async (data) => {
  const response = await axios.put(API_URL_DISMISS_REPORT, data);

  if (response.data) {
    return response.data;
  }
};
const adminCountUsersService = async () => {
  const response = await axios.get(API_URL_COUNTUSER, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const adminIndicatorService = async () => {
  const response = await axios.get(API_URL_INDICATOR, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const adminPropertyCounterService = async () => {
  const response = await axios.get(API_URL_COUNTPROPERTY, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const adminViewCounterService = async () => {
  const response = await axios.get(API_URL_VIEWCOUNTER, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const adminMessageCounterService = async () => {
  const response = await axios.get(API_URL_MESSAGECOUNTER, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const getReportService = async () => {
  const response = await axios.get(API_URL_GETREPORT, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const getFaqService = async () => {
  const response = await axios.get(API_URL_GETFAQ, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const postFaqService = async (data) => {
  const response = await axios.post(API_URL_POST_FAQ, data);

  if (response.data) {
    return response.data;
  }
};
const updateFaqService = async (data) => {
  const response = await axios.put(API_URL_UPDATE_FAQ, data);

  if (response.data) {
    return response.data;
  }
};
const updateFaqCategoryService = async (data) => {
  const response = await axios.put(API_URL_UPDATE_FAQ_CATEGORY, data);

  if (response.data) {
    return response.data;
  }
};
const deleteFaqService = async (data) => {
  const response = await axios.delete(API_URL_DELETE_FAQ, { data });

  if (response.data) {
    return response.data;
  }
};
const postFaqCategoryService = async (data) => {
  const response = await axios.post(API_URL_POST_FAQ_CATEGORY, data);

  if (response.data) {
    return response.data;
  }
};
const postDownloadImageService = async (data) => {
  const response = await axios.post(API_URL_POST_DOWNLOAD_IMAGE, data, {
    responseType: "blob",
    withCredentials: true,
  });

  if (response.data) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "images.zip"); // or dynamic name
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};
const getFaqCategoryService = async () => {
  const response = await axios.get(API_URL_GET_FAQ_CATEGORY, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};
const getHistoryService = async () => {
  const response = await axios.get(API_URL_GET_HISTORY, {
    withCredentials: true,
  });

  if (response.data) {
    return response.data;
  }
};

const adminIsLoggedInService = async () => {
  const response = await axios.post(API_URL_ADMINISLOGGEDIN, {
    withCredentials: true,
  });
  return response.data;
};

const adminAuthService = {
  adminGetAllHomesService,
  adminLoginService,
  adminChangeStatusHomeService,
  adminRegisterService,
  adminIsLoggedInService,
  adminCountUsersService,
  adminPropertyCounterService,
  adminViewCounterService,
  adminMessageCounterService,
  getReportService,
  getFaqService,
  postFaqService,
  updateFaqService,
  deleteFaqService,
  postFaqCategoryService,
  postDownloadImageService,
  getFaqCategoryService,
  adminDismissReportService,
  updateFaqCategoryService,
  getHistoryService,
  adminIndicatorService
};
export default adminAuthService;
